import { Time as NgTime } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { Time } from '../time/time';

@Pipe({
  name: 'time',
})
export class TimePipe implements PipeTransform {
  public transform(value: Time | NgTime, format: string = 'H:mm'): string {
    if (value) {
      const time: NgTime = Time.isTime(value) ? TimePipe.toNgTime(value) : value;
      if (time) {
        return moment(time, 'HH:mm:ss').format(format).replace(/:/, 'h');
      }
    }
  }

  private static toNgTime(value: Time): NgTime {
    const str: string = Time.toString(value).toString();
    return str ? (str as unknown as NgTime) : undefined;
  }
}
